import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  siteBoxDocumentsKeys,
  RequestTypes,
} from '@core/react-query/features/siteBoxDocuments'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ISiteBoxDocumentDownload } from '@core/entities/SiteBoxDocument/ISiteBoxDocumentDownload'

export const useCreateSiteboxAppraisalSheet = (
  options?: UseMutationOptions<
    ISiteBoxDocumentDownload,
    RequestErrorType,
    RequestTypes['createSiteboxAppraisalSheet']
  >,
) => {
  return useMutation({
    ...siteBoxDocumentsKeys.createSiteboxAppraisalSheet,
    ...options,
  })
}
